import React from 'react';
import config from '@plone/volto/registry';
import { TextWithGlossaryTooltips } from '@rohberg/volto-slate-glossary/utils';

const DefaultImage = (props) => <img {...props} alt={props.alt || ''} />;

const ImageCarousel = ({ data }) => {
  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const Image = config.getComponent('Image').component || DefaultImage;

  return (
    <div className="image-carousel-item">
      {image && (
        <div className="highlight-image-wrapper gradient">
          <Image
            item={image || href}
            imageField={image.image_field}
            alt=""
            loading="lazy"
            responsive={true}
          />
        </div>
      )}
      <p>{<TextWithGlossaryTooltips text={data?.description} />}</p>
    </div>
  );
};

export default ImageCarousel;
